import { Body, Controller, Req } from '@nestjs/common';
import { ApiBearerAuth, ApiTags } from '@nestjs/swagger';

import { PusherAuthenticateInputModel, PusherAuthenticateOutputModel, PusherAuthorizeInputModel, PusherAuthorizeOutputModel } from '../models';
import { UpdateResponse } from '../responses';
import { PusherService } from '../services';
import { Request } from '../types';

@ApiBearerAuth()
@ApiTags('Pusher')
@Controller()
export class PusherController {
  constructor(private readonly pusherService: PusherService) {}

  @UpdateResponse('/pusher.authenticate', PusherAuthenticateOutputModel)
  public authenticate(@Body() pusherAuthenticateInputModel: PusherAuthenticateInputModel, @Req() request: Request): PusherAuthenticateOutputModel {
    return this.pusherService.authenticate(pusherAuthenticateInputModel, request);
  }

  @UpdateResponse('/pusher.authorize', PusherAuthorizeOutputModel)
  public authorize(@Body() pusherAuthorizeInputModel: PusherAuthorizeInputModel): PusherAuthorizeOutputModel {
    return this.pusherService.authorize(pusherAuthorizeInputModel);
  }
}
